import { useActionCreators, useAppSelector } from 'shared/hooks'

import { actions, selectors } from '../../slice'

export function Default() {
	const message = useAppSelector(selectors.message)
	const { resetSnack } = useActionCreators(actions)

	return (
		<div className='snackbar-notification__message'>
			<div className='snackbar-notification__icon' />
			<div className='snackbar-notification__body'>
				<div className='snackbar-notification__title'>
					<span>{message.title}</span>
					<div
						className='snackbar-notification__icon-close'
						onClick={() => resetSnack()}
					/>
				</div>
				<div
					className='snackbar-notification__text'
					dangerouslySetInnerHTML={{ __html: message.content }}
				/>
				{message.button && (
					<div className='notification-button'>
						<a
							className='btn'
							href={message.button.link}
							rel='noopener noreferrer'
							target='_blank'
						>
							{message.button.title}
						</a>
					</div>
				)}
			</div>
		</div>
	)
}
